// extracted by mini-css-extract-plugin
export default {"content":"Main_content__msFME","invert":"Main_invert__YBUyR","marginTop":"Main_marginTop__gg4fT","button":"Main_button__IMu05"};